
import { Component, Vue } from 'vue-property-decorator'
import { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import { HttpAxiosError, ApiResponse } from '@/plugins/http'

/** ヘルプ：作成・編集表示型 */
export type HelpEditItem = {
  helpGroupId: SelectOption['value']
  sortNum: number
  title: string
  isVisible: boolean
  message: string
}

/** ヘルプ：バリデーションメッセージ型 */
export type HelpValidationMessage = {
  helpGroupId: string
  sortNum: string
  title: string
  message: string
}

@Component
export default class HelpEditApis extends Vue {
  /**
   * ヘルプ：対象情報取得
   */
  protected async showHelpItemApi(helpContentId: number): Promise<HelpEditItem | null> {
    try {
      const { data }: { data: HelpEditItem } = await Vue.prototype.$http.httpWithToken.get(
        `/v1/help_contents/${helpContentId}`
      )
      Vue.prototype.$logger.log(data)

      const message = await Vue.prototype.$compress.base64ToString(data.message)
      if (message !== null) data.message = message

      return data
    } catch (error: any) {
      Vue.prototype.$logger.error(error)
      return null
    }
  }

  /**
   * ヘルプ：新規作成
   */
  protected async createHelpItemApi(
    helpEditItem: HelpEditItem,
    onSuccess: () => Promise<void>,
    onError: (error: ApiResponse | null) => Promise<void>
  ): Promise<void> {
    const base64Message = await Vue.prototype.$compress.stringToBase64(helpEditItem.message)

    await Vue.prototype.$http.httpWithToken
      .post('/v1/help_contents', {
        helpGroupId: helpEditItem.helpGroupId,
        sortNum: helpEditItem.sortNum,
        title: helpEditItem.title,
        isVisible: helpEditItem.isVisible,
        message: base64Message == null ? helpEditItem.message : base64Message,
      })
      .then(async () => {
        await onSuccess()
      })
      .catch(async (error: HttpAxiosError) => {
        if (error.response) {
          await onError(error.response.data instanceof Blob ? null : error.response.data)
        } else {
          await onError(null)
        }
      })
  }

  /**
   * ヘルプ：更新編集
   */
  protected async updateHelpItemApi(
    helpContentId: number,
    helpEditItem: HelpEditItem,
    onSuccess: () => Promise<void>,
    onError: (error: ApiResponse | null) => Promise<void>
  ): Promise<void> {
    const base64Message = await Vue.prototype.$compress.stringToBase64(helpEditItem.message)

    await Vue.prototype.$http.httpWithToken
      .patch(`/v1/help_contents/${helpContentId}`, {
        helpGroupId: helpEditItem.helpGroupId,
        sortNum: helpEditItem.sortNum,
        title: helpEditItem.title,
        isVisible: helpEditItem.isVisible,
        message: base64Message == null ? helpEditItem.message : base64Message,
      })
      .then(async () => {
        await onSuccess()
      })
      .catch(async (error: HttpAxiosError) => {
        if (error.response) {
          await onError(error.response.data instanceof Blob ? null : error.response.data)
        } else {
          await onError(null)
        }
      })
  }
}
